module.exports = __webpack_public_path__ + "media/warning.dc49298a.mp3";